import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component
import SvgMenuIcon from '@/components/SvgMenuIcon'// svg component
// register globally
Vue.component('svg-icon', SvgIcon)
Vue.component('svg-menu-icon', SvgMenuIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
